// PGCET MCA Mock 6 — General English (questions 91–100)
const PASSAGE = "\"Groundwater is the water stored beneath the earth's surface in the pores of soil and in the cracks of rocks. In many parts of India it supplies more than half of the water used for irrigation and most of the drinking water in villages. Because it cannot be seen, groundwater is often treated as an endless resource. Farmers drill deeper and deeper borewells, and cities pump out far more water than the rains can replace. As a result, water tables in several districts have fallen sharply, and wells that once yielded water throughout the year now run dry in summer. Experts argue that the solution lies not only in using less water but also in helping the earth recharge itself: building check dams, reviving old tanks and lakes, and harvesting rainwater from rooftops.\"";

const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Choose the word nearest in meaning to AMELIORATE.",
    options: ["A. Worsen", "B. Improve", "C. Abandon", "D. Accuse"],
    answer: "B"
  },
  {
    id: 92,
    question: "Choose the word nearest in meaning to UBIQUITOUS.",
    options: ["A. Rare", "B. Unique", "C. Omnipresent", "D. Ambiguous"],
    answer: "C"
  },
  {
    id: 93,
    question: "Choose the antonym of AUSTERE.",
    options: ["A. Severe", "B. Strict", "C. Plain", "D. Luxurious"],
    answer: "D"
  },
  {
    id: 94,
    question: "Choose the antonym of DILIGENT.",
    options: ["A. Indolent", "B. Industrious", "C. Careful", "D. Attentive"],
    answer: "A"
  },
  {
    id: 95,
    question: "Find the part of the sentence that contains an error: She has been living (A) / in Bengaluru (B) / since five years (C) / No error (D)",
    options: ["A. She has been living", "B. in Bengaluru", "C. since five years", "D. No error"],
    answer: "C"
  },
  {
    id: 96,
    question: "Find the part of the sentence that contains an error: If I was you (A) / I would accept (B) / the offer immediately (C) / No error (D)",
    options: ["A. If I was you", "B. I would accept", "C. the offer immediately", "D. No error"],
    answer: "A"
  },
  {
    id: 97,
    question: "Find the part of the sentence that contains an error: The scenery of Coorg (A) / is very beautiful (B) / during the monsoon (C) / No error (D)",
    options: ["A. The scenery of Coorg", "B. is very beautiful", "C. during the monsoon", "D. No error"],
    answer: "D"
  },
  {
    id: 98,
    question: `Read the passage and answer the question: ${PASSAGE} According to the passage, why is groundwater often over-used?`,
    options: [
      "A. Because it is cleaner than river water",
      "B. Because it cannot be seen and is wrongly regarded as an endless resource",
      "C. Because the government supplies it free of cost",
      "D. Because rainfall has increased in recent years"
    ],
    answer: "B"
  },
  {
    id: 99,
    question: `Read the passage and answer the question: ${PASSAGE} What has been the result of excessive extraction of groundwater?`,
    options: [
      "A. Water tables have fallen and many wells run dry in summer",
      "B. Rainfall in several districts has decreased",
      "C. Villages have stopped using groundwater for drinking",
      "D. Cities have begun to depend entirely on rivers"
    ],
    answer: "A"
  },
  {
    id: 100,
    question: `Read the passage and answer the question: ${PASSAGE} Which of the following is NOT suggested in the passage as a way to help the earth recharge itself?`,
    options: [
      "A. Building check dams",
      "B. Reviving old tanks and lakes",
      "C. Drilling more deep borewells",
      "D. Harvesting rainwater from rooftops"
    ],
    answer: "C"
  }
];

export default pgcetmcaGeneralEnglish;
